import { takeLatest } from 'redux-saga/effects';
import { LOAD_USER_ACTION_LIST } from '../actions';
import { USER_ACTION_LOG_PAGE_MODULE } from '../../../configs/moduleNames';
import loadUserActionList from './loadUserActionList';

export default function* sagas() {
  yield takeLatest(USER_ACTION_LOG_PAGE_MODULE + LOAD_USER_ACTION_LIST, loadUserActionList);
}
